import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';

import { BLACK } from '../../theme/colorConstants';
import { PRIMARY_FONT } from '../../theme/fontConstants';

import { INVALID_WORKER_FILTERS, UI_TEXT } from './constants/modalConstants';

const titleStyle = {
  fontSize: '18px',
  fontFamily: PRIMARY_FONT[700],
  color: BLACK[100],
  marginBottom: '8px',
};

const descriptionStyle = {
  fontSize: '14px',
  color: BLACK[90],
  marginBottom: '16px',
};

const checkboxLabelStyle = {
  '& .MuiFormControlLabel-label': {
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[400],
    color: BLACK[100],
  },
};

const InvalidWorkersSection = ({ value, onChange, disabled }) => {
  const handleChange = (key) => {
    onChange({
      ...value,
      [key]: !value[key],
    });
  };

  return (
    <Box sx={{ marginTop: '32px' }}>
      <Typography sx={titleStyle}>{LanguageConverterV2(UI_TEXT.INVALID_WORKERS)}</Typography>
      <Typography sx={descriptionStyle}>
        {LanguageConverterV2(UI_TEXT.INVALID_WORKERS_DESCRIPTION)}
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={value[INVALID_WORKER_FILTERS.OVERTIME_BLOCKED] || false}
                onChange={() => handleChange(INVALID_WORKER_FILTERS.OVERTIME_BLOCKED)}
                disabled={disabled}
              />
            }
            label={LanguageConverterV2(UI_TEXT.OVERTIME_BLOCKED)}
            sx={checkboxLabelStyle}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={value[INVALID_WORKER_FILTERS.CONFLICTING_SCHEDULE] || false}
                onChange={() => handleChange(INVALID_WORKER_FILTERS.CONFLICTING_SCHEDULE)}
                disabled={disabled}
              />
            }
            label={LanguageConverterV2(UI_TEXT.CONFLICTING_SCHEDULE)}
            sx={checkboxLabelStyle}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={value[INVALID_WORKER_FILTERS.SUSPENDED] || false}
                onChange={() => handleChange(INVALID_WORKER_FILTERS.SUSPENDED)}
                disabled={disabled}
              />
            }
            label={LanguageConverterV2(UI_TEXT.SUSPENDED)}
            sx={checkboxLabelStyle}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={value[INVALID_WORKER_FILTERS.INCOMPLETE_ONBOARDING] || false}
                onChange={() => handleChange(INVALID_WORKER_FILTERS.INCOMPLETE_ONBOARDING)}
                disabled={disabled}
              />
            }
            label={LanguageConverterV2(UI_TEXT.INCOMPLETE_ONBOARDING)}
            sx={checkboxLabelStyle}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={value[INVALID_WORKER_FILTERS.NOT_QUALIFIED] || false}
                onChange={() => handleChange(INVALID_WORKER_FILTERS.NOT_QUALIFIED)}
                disabled={disabled}
              />
            }
            label={LanguageConverterV2(UI_TEXT.NOT_QUALIFIED)}
            sx={checkboxLabelStyle}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={value[INVALID_WORKER_FILTERS.IMPROPER_EOR_OR_JOB_FULL] || false}
                onChange={() => handleChange(INVALID_WORKER_FILTERS.IMPROPER_EOR_OR_JOB_FULL)}
                disabled={disabled}
              />
            }
            label={LanguageConverterV2(UI_TEXT.IMPROPER_EOR_OR_JOB_FULL)}
            sx={checkboxLabelStyle}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

InvalidWorkersSection.propTypes = {
  value: PropTypes.shape({
    overtimeBlocked: PropTypes.bool,
    suspended: PropTypes.bool,
    notQualified: PropTypes.bool,
    conflictingSchedule: PropTypes.bool,
    incompleteOnboarding: PropTypes.bool,
    improperEorOrJobFull: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

InvalidWorkersSection.defaultProps = {
  disabled: false,
};

export default InvalidWorkersSection;
